import styled from 'styled-components';

export default styled.div`
    .betslip-share-button {
        margin-bottom: var(--spacing-8);
    }

    .modal-container {
        padding: var(--spacing-8) var(--spacing-16);

        .title {
            font-size: var(--font-16);
        }

        .social-media-container {
            display: flex;
            margin-top: var(--spacing-24);
            gap: var(--spacing-12);

            .box {
                cursor: pointer;
                margin-right: var(--spacing-8);

                .copy-icon {
                    display: block;
                }
            }
        }

        .pointer {
            cursor: pointer;
        }
    }
`;
